import { RouterProvider } from 'react-router-dom';
import { IdentityProvider } from '@/features/auth/identity';
import { router } from '@/app/routes';

export function App() {
  return (
    <IdentityProvider>
      <RouterProvider router={router} />
    </IdentityProvider>
  );
}
